import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';

import {
    fetchSocialCalloutsByObjective,
} from 'services/social/duck';

import { SocialObjectiveDashboardComponent } from 'containers/dashboards/DashboardBaseComponent';
import GenericSocialModule from 'components/organisms/social/GenericSocialModule';

class GenericSocialContainer extends SocialObjectiveDashboardComponent {
    constructor(props) {
        super(props, props.objective);
    }

    makeRequestsForData() {
        const entityId = this.getCurrentEntityId();
        const objective = this.getCurrentObjective();
        const payload = this.createPayload(entityId, objective);

        this.props.fetchSocialCalloutsByObjective(payload);
    }

    render() {
        return (
            <GenericSocialModule module={this.props.module}
                xAxisLabel={this.props.xAxisLabel}
                backfillBuckets={this.props.backfillBuckets}
                objective={this.props.objective || this.props.entityObjective}
                layer={this.props.layer}
            />
        );
    }
}

const mapStateToProps = (state, props) => ({
    entityMeta: state.entities.meta,
    module: state.social.facebook.objectives[props.objective],
    selectedTimeRange: state.config.selectedTimeRange,
    xAxisLabel: get(state, 'config.timeBuckets.config.xAxisLabel', 'Date'),
    backfillBuckets: get(state, 'config.timeBuckets.config.buckets', [])
});

export default connect(mapStateToProps, {
    fetchSocialCalloutsByObjective,
})(GenericSocialContainer);



// WEBPACK FOOTER //
// ./src/containers/dashboards/social/GenericSocialContainer.js